var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproveGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "-4.767 -7.369 30 30",
    enableBackground: "new -4.767 -7.369 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    fill: "#B6B6AC",
    d: "M6.223,16.586l-8.124-8.125c-0.488-0.488-0.488-1.279,0-1.767l0,0l1.768-1.768 c0.488-0.488,1.279-0.489,1.767,0l0,0L7.107,10.4L18.832-1.325c0.489-0.488,1.279-0.488,1.768,0l0,0l1.768,1.768 c0.488,0.488,0.489,1.278,0,1.766l0,0L7.992,16.586c-0.487,0.489-1.278,0.49-1.767,0.002C6.225,16.587,6.224,16.587,6.223,16.586z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveGrey);
export default __webpack_public_path__ + "static/media/approve-grey.7df81a0a3db15c08c9d57c52ae455400.svg";
export { ForwardRef as ReactComponent };